import { useNavigate } from 'react-router-dom'
import { Product } from './style'
import { getProductFromListApi } from '../../../api'
import { useMixPanel } from '../../../hooks/useMixPanel';
import { useGtag } from '../../../hooks/useGtag';
import ImageViewer from "awesome-image-viewer";

const List = ({ item, isLoading, setIsLoading, setPreviewProduct, setOpenItemPreviewModal, createSlug = false}) => {
    const navigate = useNavigate()
    const { mixPanelEvent, mixPanelServerEvent } = useMixPanel()
    const { gtagViewDownloadEvent } = useGtag()

    const trackImageView = () => {
    if (item?.url) {
    const data = {
      product_id: item?.product_id,
      type: item?.name,
      product_name: item?.product_name,
      file_name: item?.name,
      file_url: item?.url
    }
    mixPanelEvent('Image View', data)
    mixPanelServerEvent('Image View', data)
    gtagViewDownloadEvent('image_view', data)
  }
  }

    const viewImages = () => {
        let images = []
        setIsLoading(true)
        const sortedImages = item?.other_images.sort((a, b) => {
            if (a.name === item.name) return -1;
            if (b.name === item.name) return 1;
            return a.name.localeCompare(b.name);
        });
        images = sortedImages?.map(image => ({
            mainUrl: image?.url ? `${process.env.REACT_APP_GALLERY_URL}2000:2000:${image?.url?.split('.com/')[1]}` : '',
            ...image
        }))
        setIsLoading(false)
        new ImageViewer({
            images: images?.filter((_i) => _i.url !== ''),
            closeOnEsc: true,
            isZoomable: false,
            closeOnOutsideClick: true
        })
        trackImageView()
    }

    const getProductFromList = (id) => {
    setIsLoading(true)
    getProductFromListApi(id).then(res => {
      if (res && res.data) {
        setPreviewProduct(res?.data?.products[0])
        setIsLoading(false)
        setOpenItemPreviewModal(true)
      }
      setIsLoading(false)
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }


    return (
        <Product>
            <div className='product-details'>
                <h4><strong>{item.product_mid_code}-{item.product_material}</strong></h4>
                <h4>{item.product_name}</h4>
            </div>
            <div className="btn-container">
                <button className='btn transparent view-btn'
                    onClick={viewImages}
                >View {item?.other_images && item?.other_images.length > 1 ? 'Images' : 'Image'}</button>
                <button className='btn add-btn'
                    onClick={() => {
                        if (isLoading) return
                        getProductFromList(item?.product_id)
                        if (createSlug) {
                        navigate(`/product-search/${item?.product_handle}`)
                        }
                    }}
                ><i className='fal fa-eye'></i>View Product</button>
            </div>
        </Product>
    )
}

export default List